import { makeStyles } from 'tss-react/mui'
import { ButtonProps } from '@mui/material'

export default makeStyles<ButtonProps>()(() => {
  return {
    root: {
      textTransform: 'uppercase',
      textAlign: 'center',

      '&:disabled': {
        border: 'none'
      },

      lineHeight: '150%',
      flex: 'none',
      order: 0,
      flexGrow: 1,
      position: 'relative'
    },
    arrow: {
      marginLeft: '0.25rem',
      fontSize: '1rem'
    }
  }
})
